/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const localizationListSchema = z
	.object({
		ru: z.array(z.string()).optional(),
		en: z.array(z.string()).optional(),
		es: z.array(z.string()).optional(),
		ar: z.array(z.string()).optional(),
		zh: z.array(z.string()).optional(),
		kk: z.array(z.string()).optional(),
		hy: z.array(z.string()).optional(),
		ka: z.array(z.string()).optional(),
		az: z.array(z.string()).optional(),
		uz: z.array(z.string()).optional(),
	})
	.describe("Util serializer for representation in swagger");
